import { createElectronPlugin } from './electron-plugin.util';

interface SplashScreenPlugin {
    hide: () => Promise<void>;
    transitionToUpdate: () => Promise<void>;
    showActivatingState: () => Promise<void>;
    showRestartPrompt: () => Promise<void>;
}

class SplashScreenWeb implements SplashScreenPlugin {
    async hide(): Promise<void> {
        const splash = document.getElementById('splash');
        if (splash) {
            splash.style.pointerEvents = 'none';
            splash.style.opacity = '0';
            splash.addEventListener('transitionend', () => splash.remove());
            setTimeout(() => splash.remove(), 500);
        }
    }

    async transitionToUpdate(): Promise<void> {
        const info = document.getElementById('splash-info');
        const update = document.getElementById('splash-update');
        const title = document.getElementById('update-title');
        if (info) info.style.display = 'none';
        if (update) update.style.display = 'flex';
        if (title) title.textContent = 'Update Available';
    }

    async showActivatingState(): Promise<void> {
        const progress = document.getElementById('update-progress');
        const text = document.getElementById('update-text');
        if (progress) progress.style.display = 'none';
        if (text) {
            text.style.display = 'block';
            text.textContent = 'Installing update...';
        }
    }

    async showRestartPrompt(): Promise<void> {
        const text = document.getElementById('update-text');
        const btn = document.getElementById('update-btn') as HTMLButtonElement | null;
        if (text) text.textContent = 'Update ready — restart to apply';
        if (btn) {
            btn.textContent = 'Restart';
            btn.style.display = 'block';
            btn.onclick = () => document.location.reload();
        }
    }
}

const SplashScreenElectron = createElectronPlugin<SplashScreenPlugin>('SplashScreen', {
    web: () => new SplashScreenWeb()
});

export default SplashScreenElectron;
